<template>
    <v-expansion-panel>
        <v-expansion-panel-header hide-actions>
            <template v-slot:default="{ open }">
                <div class="d-flex align-center">
                    <div class="text-subtitle-1 font-weight-bold">{{ title }}</div>
                    <v-icon v-if="open">arrow_drop_up</v-icon>
                    <v-icon v-if="!open">arrow_drop_down</v-icon>
                </div>
            </template>
        </v-expansion-panel-header>
        <v-expansion-panel-content eager>
            <div class="pb-4" v-if="isContract">
                <v-row>
                    <v-col cols="4" class="shallowGray--text">Код объекта</v-col>
                    <v-col class="black--text">{{ infoCreate.obj_contract_number }}</v-col>
                </v-row>
                <v-row>
                    <v-col cols="4" class="shallowGray--text">Наименование объекта</v-col>
                    <v-col class="black--text">{{ infoCreate.object_name }}</v-col>
                </v-row>
                <v-row>
                    <v-col cols="4" class="shallowGray--text">Адрес</v-col>
                    <v-col class="black--text">{{ infoCreate.object_address_full_name }}</v-col>
                </v-row>
            </div>
            <div>
                <v-row>
                    <v-col>
                        <v-select
                            ref="injuction_rid"
                            :attach="true"
                            hide-details
                            outlined
                            color="primaryDark"
                            label="Предписание"
                            v-model="form.injuction.injuction_rid"
                            :items="injuctions"
                            item-text="injuct_name"
                            item-value="record_id"
                            :rules="shouldValidate ? [validationRules.required] : []"
                            @change="validateInjuction"
                        />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="4">
                        <PreTrialDatePicker
                            ref="period_execution"
                            label="Срок исполнения до"
                            :date.sync="form.injuction.period_execution"
                            :required="shouldValidate"
                            @change="validateInjuction"
                        />
                    </v-col>
                </v-row>
                <v-radio-group
                    ref="injuction_done"
                    :rules="shouldValidate ? [validationRules.required_bool] : []"
                    row
                    v-model="form.injuction.injuction_done"
                    @change="validateInjuction"
                >
                    <v-radio
                        color="gray"
                        v-for="(injuctionType, idx) of injuctionTypes"
                        :key="idx"
                        :label="injuctionType.label"
                        :value="injuctionType.value"
                    ></v-radio>
                </v-radio-group>
                <p v-if="this.isContract && shouldValidate && showInjuctionError" style="color: #ff5252">Поля обязательны к заполнению одновременно</p>
                <v-btn v-if="this.isContract" @click="clearInjuction" class="mr-4" color="gray" outlined rounded>Очистить предписание</v-btn>
            </div>
            <div class="pt-8">
                <div class="text-h6 gray--text">Система теплоснабжения</div>
                <v-radio-group v-model="form['heating_system_rid']">
                    <v-radio v-for="heating of heatingSystem" :key="heating.record_id" :value="heating['record_id']" color="gray">
                        <template v-slot:label>
                            <div class="gray--text">{{ heating['heating_system_name'] }}</div>
                        </template>
                    </v-radio>
                </v-radio-group>
            </div>
        </v-expansion-panel-content>
        <v-divider color="gray" />
    </v-expansion-panel>
</template>
<script>
import PreTrialDatePicker from '@/components/pre-trial-notices/PreTrialDatePicker.vue';
import translate from '@/utils/translate.util';
import { mapGetters } from 'vuex';
import { validationRules } from '@/utils/validationRules';

export default {
    name: 'PrescribedInfoAccount',
    components: { PreTrialDatePicker },
    props: ['value', 'isContract', 'infoCreate'],
    data: function() {
        return {
            injuctionTypes: [
                {
                    value: true,
                    label: 'Предписание исполнено'
                },
                {
                    value: false,
                    label: 'Предписание не исполнено'
                }
            ]
        };
    },
    computed: {
        validationRules() {
            return validationRules;
        },
        ...mapGetters('refs', ['getInjuctionsList', 'getHeatingSystem']),
        form: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            }
        },
        injuctions() {
            return translate(this.getInjuctionsList, 'full', this.$i18n.locale);
        },
        heatingSystem() {
            return translate(this.getHeatingSystem, 'full', this.$i18n.locale);
        },
        shouldValidate() {
            return !!(
                this.form.injuction.injuction_rid ||
                this.form.injuction.injuction_done ||
                this.form.injuction.injuction_done === false ||
                this.form.injuction.period_execution
            );
        },
        showInjuctionError() {
            return this.form.injuction.injuction_rid == null || this.form.injuction.injuction_done == null || this.form.injuction.period_execution == null;
        },
        title() {
            return this.isContract ? 'Сведения по объекту договора' : 'Сведения по предписанию';
        }
    },
    methods: {
        clearInjuction() {
            this.form.injuction.injuction_rid = null;
            this.form.injuction.injuction_done = null;
            this.form.injuction.period_execution = null;
        },
        validateInjuction() {
            if (this.isContract) {
                this.$refs.injuction_done.validate(true);
                this.$refs.injuction_rid.validate(true);
                this.$refs.period_execution.validateDateField();
            }
        }
    }
};
</script>

<style scoped></style>
